var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e3f5ccdcee716c57621c49f40870505783e43e64"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["customer-frontend@linkgraph"]={id:"e3f5ccdcee716c57621c49f40870505783e43e64"};
      